import { tableFiltersUrl } from '../../utils/helper'
import request from '../axiosInterceptor'

const api = {
  getMasterDetails(data?: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/master-details?${data || 'workspace=true&language=true&theme=true&license_type=true&package_type=true&app_module=true'}`,
      method: 'get',
    })
  },
  getAllBot(data?: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/copilots-languages?${data || 'workspace=true&language=true&theme=true&license_type=true&package_type=true&app_module=true'}`,
      method: 'get',
    })
  },
  getAllCountries() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/common/countries-list`,
      method: 'get',
    })
  },
  getWebModules() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/user-roles/modules-list`,
      method: 'get',
    })
  },
  getWebPermission() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/user-roles/permission-list`,
      method: 'get',
    })
  },
  getAllDivision(data?: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/division-list?${data ? tableFiltersUrl(data) : ''}`,
      method: 'get',
    })
  },
  getAllTimezones() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/time-zone-list`,
      method: 'get',
    })
  },
  getAllHazardType(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/hazard-type-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllRootCause(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/root-cause-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllSeverity(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/severity-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllObservationStatus(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/observation-status-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllStatisticsCaptureStatus(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/statistic-capture-status-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  // delete post sc release
  // getAllStatisticsCaptureInputs(data: any) {
  //   return request({
  //     url: `${process.env.REACT_APP_API_BASEURL}v1/master/statistic-capture-master-list?${tableFiltersUrl(data)}`,
  //     method: 'get',
  //   })
  // },
  getAllIncidentStatus(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/incident-status-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllIncidentCategory(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/incident-category-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllIncidentSeverity(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/incident-severity-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getIncidentCommunication() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/incident-communication`,
      method: 'get',
    })
  },
  getIncidentFurtherAction() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/incident-further-actions`,
      method: 'get',
    })
  },
  getAllInspectionStatus(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/inspection-status?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllInspectionScheduleStatus(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/inspection-schedule-status?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllInspectionNonConformanceStatus(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/inspection-nc-status?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllInspectionSubCategory(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/inspection-subcategories?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllInspectionTopic(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/inspection-topic?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllInspectionQuestions(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/inspection-question?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getAllCopilotsForDropdown(id: string) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/nai-hub/subsidiary-copilot-list`,
      method: 'get',
    })
  },
  getAllTrainingCategory(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/training-category?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getRulesAndEscalationMAster() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/rules-escalation`,
      method: 'get',
    })
  },
  getRulesAndEscalationUsers(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/project-users`,
      method: 'get',
    })
  },
  getRulesAndEscalationRoles(id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/project-management/${id}/rules-escalation/project-roles`,
      method: 'get',
    })
  },
  getAllSOR() {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/master/record-type`,
      method: 'get',
    })
  },
}

export default api
